import type { PhotoWidgetData } from '@/types';

interface PhotoWidgetProps {
  data: PhotoWidgetData;
}

const PhotoWidget = ({ data }: PhotoWidgetProps) => {
  return (
    <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-soft dark:shadow-none overflow-hidden">
      <img
        src={data.imageUrl}
        alt={data.caption || 'Photo'}
        className="w-full aspect-square object-cover"
      />
      {data.caption && (
        <div className="p-4">
          <p className="text-dark-800 dark:text-gray-100 text-sm">{data.caption}</p>
        </div>
      )}
    </div>
  );
};

export default PhotoWidget;
